export const REQUEST_STATUS = {
  new: 1,
  accepted: 2,
  rejected: 3,
};

export const DEFAULT_CARD_NUMBER_TEMPLATE = '####-####';

export default {
  REQUEST_STATUS,
  DEFAULT_CARD_NUMBER_TEMPLATE,
};
